"use client";
import React, {ReactNode, useContext, useState} from "react";
import {usePathname} from "next/navigation";
import Link from "next/link";
import NotificationContext from "../Layouts/NotificationContext"
import {createClient} from "@repo/shared/supabase/client";

interface SidebarLinkGroupProps {
    path: string;
    title: ReactNode,
    module: string
}

const SidebarLink = ({
    path,
    title,
    module
}: SidebarLinkGroupProps) => {
    const supabase = createClient();
    const pathname = usePathname();
    const {notifications} = useContext(NotificationContext)
    async function markNotificationAsViewed(notificationId: number) {
        const {data, error} = await supabase
            .from('notifications')
            .update({viewed: true})
            .eq('id', notificationId);

        if (error) {
            console.error("Error marking notification as viewed:", error.message);
            return null;
        }
        return data;
    }
    // ${(pathname === path || pathname.includes(path)) ? "bg-[#83d7cf] " : 'text-white'}

    return <li>
            <Link
                href={path}
                className={`group relative flex items-center gap-2.5 rounded-md px-4  py-2 font-medium hover:bg-[#83d7cf] hover:text-graydark duration-300 ease-in-out text-white`}
                onClick={() => {
                    const notViewedNotifications = notifications.filter((notification:any) => notification.module === module && !notification.viewed)
                    notViewedNotifications.forEach((n:any) => markNotificationAsViewed(n.id))
                }}
            >
                {title}
                {notifications.filter((notification:any) => notification.module === module && !notification.viewed).length ?
                    <button
                        className="inline-flex rounded-full bg-[#DC3545] px-3 py-1 text-sm font-medium text-white hover:bg-opacity-90">
                        {notifications.filter((notification:any) => notification.module === module && !notification.viewed).length}
                    </button>
                    : ""}
            </Link>
    </li>;
};

export default SidebarLink;
